<template>
  <v-container class="p-3 mt-5">
    <loading-flux :value="loading"></loading-flux>
    <header
      class="d-flex flex-column flex-sm-row justify-content-between"
      v-if="showHeader"
    >
      <h2 class="ml-1 my-2">
        {{ title }}
      </h2>
      <v-breadcrumbs :items="breadcrumb"></v-breadcrumbs>
    </header>
    <v-row align-content="start" align-md="start" class="mt-1">
      <slot name="actions"></slot>
      <v-col cols="12" md="3" sm="12" class="py-0">
        <v-text-field
          v-model="filters.filter"
          @input="getRequestsQuotesData(1)"
          class="mt-5"
          clearable
          placeholder="Buscar:"
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="3" sm="12" class="py-0">
        <v-text-field
          v-model="filters.shopping_index"
          @input="getRequestsQuotesData(1)"
          class="mt-5"
          clearable
          placeholder="Buscar por Cesta de Cotización:"
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="3" sm="12" class="pb-0">
        <v-autocomplete
          v-model="filters.status_filter"
          clearable
          :items="
            QUOTE_CONSTANTS.getQuoteStatusesList().map((item) => ({
              name: getStatusCorrection(item),
              value: item,
            }))
          "
          item-text="name"
          item-value="value"
          @input="getRequestsQuotesData(1)"
          label="Filtrar por Estatus"
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" md="3" sm="12" class="pb-0">
        <v-autocomplete
          v-model="filters.assigned_filter"
          clearable
          :items="[
            {
              email: REQUEST_SERVICE_CONSTANTS.unassigned_purchase_user,
              label: 'Sin Comprador Asignado',
            },
            ...wrappedListEmployeesToAssignRequestQuote,
          ]"
          @input="getRequestsQuotesData(1)"
          class=""
          item-text="label"
          item-value="email"
          no-data-text="Sin Usuarios Compradores"
          label="Filtrar por Comprador Asignado"
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" md="3" sm="12" class="pb-0">
        <v-menu
          ref="menu"
          v-model="datepicker_menu_start"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="date_start_formatted"
              prepend-icon="mdi-calendar"
              readonly
              label="Filtrar por Fecha (Desde)"
              v-bind="attrs"
              v-on="on"
              clearable
              @click:clear="clearDateFilters"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="filters.date_start"
            scrollable
            locale="es"
            :max="maxDateStart"
            @input="
              datepicker_menu_start = false;
              getRequestsQuotesData(1);
            "
          ></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" md="3" sm="12" class="pb-0">
        <v-menu
          ref="menu"
          v-model="datepicker_menu_end"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="date_end_formatted"
              prepend-icon="mdi-calendar"
              readonly
              label="Filtrar por Fecha (Hasta)"
              v-bind="attrs"
              v-on="on"
              clearable
              @click:clear="clearDateFilters"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="filters.date_end"
            scrollable
            locale="es"
            clearable
            :min="minDateEnd"
            @input="
              datepicker_menu_end = false;
              getRequestsQuotesData(1);
            "
          ></v-date-picker>
        </v-menu>
      </v-col>
    </v-row>
    <v-data-table
      :key="keyTableRequests"
      class="px-1 elevation-3 mt-3"
      :headers="wrappedHeaders"
      :items="quotes.items"
      :items-per-page="10"
      :page.sync="filters.page"
      hide-default-footer
      :loading="loadingQuotes"
      loading-text="Cargando Cotizaciones"
      item-key="id"
      show-expand
      :expanded.sync="expanded"
      no-data-text="Sin Cotizaciones"
      @update:sort-by="updateSortBy"
      @update:sort-desc="updateSortDesc"
      :custom-sort="customSort"
    >
      <template v-slot:item="{ item, isExpanded }">
        <tr @click="clickedRow(item)">
          <td>
            <v-menu :close-on-content-click="true">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-on="on"
                  v-bind="attrs"
                  class="blue darken-3"
                  fab
                  x-small
                  outlined
                >
                  <v-icon color="white"> mdi-dots-vertical </v-icon>
                </v-btn>
              </template>
              <v-list rounded>
                <v-list-item
                  class="mb-0 pl-1"
                  v-show="
                    requestIsStatusUserValidationVariant(item) &&
                      requestingUserModule &&
                      item.approved
                  "
                >
                  <v-list-item-title
                    @click="finishQuote(item)"
                    x-small
                    class="pointer"
                  >
                    <span class="mr-2" style="font-size: 1.1rem"> 👌 </span>
                    Finalizar Cotización
                  </v-list-item-title>
                </v-list-item>
                <v-list-item
                  class="mb-0 pl-1"
                  v-if="
                    requestIsStatusUserValidationVariant(item) &&
                      requestingUserModule &&
                      item.approved
                  "
                >
                  <v-list-item-title
                    @click="updateStatusRequestToQuotation(item)"
                    x-small
                    class="pointer"
                  >
                    <span class="mr-2" style="font-size: 1.1rem"> ⚠️ </span>
                    Solicitar Recotización del Servicio
                  </v-list-item-title>
                </v-list-item>
                <v-list-item
                  class="mb-0 pl-1"
                  v-if="
                    requestIsStatusInQuotation(item) && !requestingUserModule
                  "
                >
                  <v-list-item-title
                    @click="updateStatusRequestToValidationUser(item)"
                    x-small
                    class="pointer"
                  >
                    <span class="mr-2" style="font-size: 1.1rem"> 👌 </span>
                    Enviar Solicitud a Validación por el Usuario (Validación de
                    cotizaciones)
                  </v-list-item-title>
                </v-list-item>
                <v-list-item
                  class="mb-0 pl-1"
                  v-if="
                    requestIsStatusInQuotation(item) && !requestingUserModule
                  "
                >
                  <v-list-item-title
                    @click="updateStatusRequestToReviewUser(item)"
                    x-small
                    class="pointer"
                  >
                    <span class="mr-2" style="font-size: 1.1rem"> ⚠️ </span>
                    Enviar Solicitud a Revisión por el Usuario (Corrección de
                    errores)
                  </v-list-item-title>
                </v-list-item>
                <v-list-item
                  class="mb-0 pl-1"
                  v-if="
                    requestIsStatusUserValidationVariant(item) &&
                      requestingUserModule &&
                      !item.approved
                  "
                >
                  <v-list-item-title
                    @click="updateStatusRequestToQuotation(item, true)"
                    x-small
                    class="pointer"
                  >
                    <span class="mr-2" style="font-size: 1.1rem"> 👌 </span>
                    Enviar Solicitud a Cotización por Compras
                  </v-list-item-title>
                </v-list-item>
                <v-list-item
                  class="mb-0 pl-0"
                  v-if="
                    (!requestingUserModule &&
                      requestIsStatusInQuotation(item)) ||
                      (requestingUserModule &&
                        requestIsStatusUserValidationVariant(item))
                  "
                >
                  <v-list-item-title
                    @click="updateStatusRequestToRejection(item)"
                    x-small
                    class="pointer"
                  >
                    <v-icon class="text-danger mx-1">
                      mdi-close-circle-outline
                    </v-icon>
                    <span> Rechazar Solicitud </span>
                  </v-list-item-title>
                </v-list-item>
                <v-list-item class="mb-0 mt-0 pl-1">
                  <v-list-item-title
                    @click="openModalCommentsRequest(item)"
                    x-small
                    style="margin-top: -1rem"
                    class="pointer"
                  >
                    <v-badge
                      :content="
                        item.comments && item.comments.length
                          ? item.comments.length
                          : '0'
                      "
                      :color="
                        item.comments && item.comments.length
                          ? 'success'
                          : 'red'
                      "
                      overlap
                    >
                      <v-icon
                        class="mr-2"
                        color="primary"
                        style="font-size: 1.1rem; margin-top: -2px"
                      >
                        mdi-comment-outline
                      </v-icon>
                    </v-badge>
                    <span class="mx-2"> Comentarios </span>
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </td>
          <td>
            <span class="mt-2" style="font-size: 10px">
              {{ item.shopping_index }}
            </span>
          </td>
          <td>
            <span class="mt-2" style="font-size: 10px">
              {{ item.created_by }}
            </span>
          </td>
          <td>
            <span
              class="mt-2"
              style="font-size: 10px"
              v-if="
                requestingUserModule ||
                  item.status ===
                    QUOTE_CONSTANTS.quote_statuses_list.finished ||
                  item.status ===
                    QUOTE_CONSTANTS.quote_statuses_list.rejected ||
                  item.status === QUOTE_CONSTANTS.quote_statuses_list.canceled
              "
            >
              {{
                item.assigned_users.length
                  ? item.assigned_users[0].user.email
                  : "Sin Asignar"
              }}
            </span>
            <v-autocomplete
              v-else
              class="py-1 custom-font"
              :items="wrappedListEmployeesToAssignRequestQuote"
              v-model="item.assigned_user"
              item-text="label"
              item-value="id"
              searchable
              placeholder="Selecciona un usuario"
              @change="assignUserToRequest($event, item)"
              hide-details
            ></v-autocomplete>
          </td>
          <td>
            <span class="mt-2" style="font-size: 12px">
              {{ formatDateToFormatCommon(new Date(item.created_at)) }}
            </span>
          </td>
          <td>
            <v-chip
              label
              small
              :color="getStatusColor(item.status, item.approved)"
              class="mt-2 text-white"
            >
              {{ getStatusCorrection(item.status, item.approved) }}
            </v-chip>
          </td>
          <td>
            <v-icon>
              {{ isExpanded ? "mdi-chevron-up" : "mdi-chevron-down" }}
            </v-icon>
          </td>
        </tr>
      </template>
      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length" class="bg-gray">
          <section class="my-5 px-3">
            <table-services-detail-quote
              ref="tableServicesDetail"
              :requestingUserModule="requestingUserModule"
              :request-service="item"
              @getRequestServicesAndUpdateTable="
                getRequestsQuotesData(filters.page, false, true)
              "
              @getRequestsService="getRequestsQuotesData(filters.page)"
              @getRequestsServiceAndUpdateCurrentService="
                getRequestsQuotesData(filters.page, true, false)
              "
              @updateIndexQuotesTable="updateIndexTable"
              class="mt-5"
            ></table-services-detail-quote>
          </section>
        </td>
      </template>
    </v-data-table>
    <div class="my-3 float-right">
      <v-pagination
        total-visible="8"
        v-model="filters.page"
        :length="quotes.total_pages ? quotes.total_pages : 1"
      ></v-pagination>
    </div>
    <modal-comments-service
      :modalAction="dialogCommmentsRequest"
      :closeModalComments="closeModalCommentsRequest"
      :currentRequest="currentRequest"
      @commentAdded="getRequestsQuotesData(filters.page)"
      :moduleQuote="true"
    >
    </modal-comments-service>
  </v-container>
</template>

<script>
import moment from "moment";
import { mapGetters, mapActions } from "vuex";
import { authUsuarioComputed } from "@/state/helpers";
import REQUEST_SERVICE_CONSTANTS from "@/constants/requestService";
import QUOTE_CONSTANTS from "@/constants/quotes";
import ModalCommentsService from "../components/ModalCommentsService.vue";
import exchangeRateMixin from "@/mixins/exchangeRate";
import TableServicesDetailQuote from "../components/quotes/TableServicesDetailQuote.vue";
import config from "@/config";
import { formatDateToFormatCommon } from "@/helpers/common";

export default {
  mixins: [exchangeRateMixin],
  props: {
    title: {
      type: String,
      default: "Cotizaciones",
    },
    requestingUserModule: {
      type: Boolean,
      default: false,
    },
    showHeader: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    TableServicesDetailQuote,
    ModalCommentsService,
  },
  mounted() {
    if (
      !this.requestingUserModule &&
      !this.wrappedListEmployeesToAssignRequestQuote.length
    ) {
      this.getListEmployeesToAssignRequestQuoteData();
    }
    this.getRequestsQuotesData();
    this.getUserIsSupplyingUserData();
  },
  data() {
    return {
      loading: false,
      REQUEST_SERVICE_CONSTANTS,
      QUOTE_CONSTANTS,
      dialogCommmentsRequest: false,
      dialogServicesDeleted: false,
      dialogAssignUserQuote: false,
      currentRequest: null,
      userIsSupplyingUser: false,
      loadingQuotes: false,
      debounceTime: 500,
      keyTableRequests: 1000,
      debounceRequests: null,
      debounceQuotes: null,
      debounceEmployees: null,
      breadcrumb: [
        {
          text: "Inicio",
          disabled: false,
          href: "/",
        },
        {
          text: this.title,
          disabled: true,
          href: "/requestServices/quotes/list",
        },
      ],
      expanded: [],
      tableHeaders: [
        {
          text: "Acción",
          align: "center",
          value: "action",
          sortable: false,
        },
        {
          text: "Cesta de Cotización",
          align: "center",
          value: "shopping_index",
          sortable: true,
        },
        {
          text: "Usuario que Solicita",
          align: "center",
          value: "user",
          sortable: false,
        },
        {
          text: "Comprador Asignado",
          align: "center",
          value: "assigned_users",
          width: "15%",
          sortable: false,
        },
        {
          text: "Fecha de Creación",
          align: "center",
          value: "created_at",
          sortable: true,
        },
        {
          text: "Estatus",
          align: "center",
          value: "status",
          sortable: false,
        },
        { text: "Servicios", align: "center", value: "data-table-expand" },
      ],
      datepicker_menu_start: false,
      datepicker_menu_end: false,
      filters: {
        page: 1,
        assigned_filter: null,
        only_pending: false,
        filter: "",
        date_start: null,
        date_end: null,
        shopping_index: "",
        sort_by: "created_at",
        sort_order: "desc",
      },
    };
  },
  methods: {
    ...mapActions({
      getUserIsSupplyingUser: "requestService/getUserIsSupplyingUser",
      getQuotes: "quote/getQuotes",
      sendFinishQuote: "quote/finishRequestQuote",
      sendUpdateStatusRequestToQuotationFromUser:
        "quote/updateRequestQuoteToQuotationFromUser",
      sendUpdateStatusRequestToReviewUser:
        "quote/updateRequestQuoteToReviewUser",
      sendUpdateStatusRequestToValidationUser:
        "quote/updateRequestQuoteToValidationUser",
      sendUpdateStatusRequestToRejection: "quote/updateRequestQuoteToRejection",
      sendUpdateStatusRequestToCancelFromUser:
        "quote/updateRequestQuoteToCancelFromUser",
      getListEmployeesToAssignRequestQuote:
        "quote/getListEmployeesToAssignRequestQuote",
      assignUserToRequestQuote: "quote/assignUserToRequestQuote",
      unassignUserToRequestQuote: "quote/unassignUserToRequestQuote",
    }),
    formatDateToFormatCommon,
    updateIndexTable() {
      // this.keyTableRequests = this.keyTableRequests + 1;
    },
    async getListEmployeesToAssignRequestQuoteData(search = null) {
      let self = this;
      if (search === null || !search.includes("(")) {
        clearTimeout(self.debounceEmployees);
        self.debounceEmployees = await setTimeout(async function() {
          await self.getListEmployeesToAssignRequestQuote({
            page: 0,
            password: config.password_manteiners,
            quotation_approvers: true,
            filter: search ?? undefined,
            items: 50,
          });
        }, self.debounceTime);
      }
    },
    async assignUserToRequest(value, request) {
      this.submitUpload = true;
      let payload = {
        user: this.user.email,
        quotation_id: request.id,
        approver_id: value,
      };
      if (request.assigned_users.length) {
        await this.unassignUserToRequestQuote({
          ...payload,
          approver_id: request.assigned_users[0].user.id,
        });
      }
      const resp = await this.assignUserToRequestQuote(payload);
      if (!resp || !resp.status || resp.status == 500) {
        this.$swal({
          icon: "error",
          title: "Error",
          text: "Ha ocurrido un error en el servidor, intenta nuevamente",
          position: "top-end",
          showConfirmButton: false,
          toast: true,
          timer: 3000,
          timerProgressBar: true,
        });
      }
      if (resp.status == 400) {
        this.$swal({
          icon: "error",
          title: "Error",
          text: resp.data.detail,
          position: "top-end",
          showConfirmButton: false,
          toast: true,
          timer: 3000,
          timerProgressBar: true,
        });
      }
      if (resp.status == 200) {
        this.$swal({
          icon: "success",
          title: "Excelente",
          text: `Usuario asignado correctamente`,
          position: "top-end",
          showConfirmButton: false,
          toast: true,
          timer: 3000,
          timerProgressBar: true,
        });
        this.getRequestsQuotesData();
      }
      this.loading = false;
    },
    getPriceRequest(quote) {
      if (quote.documents.length == 1) {
        return {
          price: quote.documents[0].price,
          coin: quote.documents[0].coin,
        };
      }
      let quoteSelected = quote.documents.find((item) => item.selected);
      if (!quoteSelected) {
        return null;
      }
      return {
        price: quoteSelected.price,
        coin: quoteSelected.coin,
      };
    },
    async getUserIsSupplyingUserData() {
      const resp = await this.getUserIsSupplyingUser({
        user: this.user.email,
      });
      this.userIsSupplyingUser = resp ? resp.is_abastecimiento : false;
    },
    getStatusCorrection(status, approved = false) {
      return QUOTE_CONSTANTS.getStatusCorrection(status, approved);
    },
    clickedRow(value) {
      if (this.expanded.find((item) => item.id == value.id)) {
        return (this.expanded = this.expanded.filter(
          (item) => item.id !== value.id,
        ));
      }
      this.expanded.push(value);
    },
    clearDateFilters() {
      this.filters.date_start = null;
      this.filters.date_end = null;
      this.getRequestsQuotesData(this.filters.page);
    },
    getStatusColor(status, approved = false) {
      return QUOTE_CONSTANTS.getStatusColor(status, approved);
    },
    getRequestsQuotesData(
      page = 1,
      update_current_service = false,
      updateTable = false,
    ) {
      let self = this;
      clearTimeout(self.debounceQuotes);
      self.filters.page = page;
      self.debounceQuotes = setTimeout(async () => {
        self.loadingQuotes = true;
        await this.getQuotes({
          page: self.filters.page,
          name_filter: this.filters.filter ? this.filters.filter : undefined,
          user_filter: this.requestingUserModule ? this.user.email : undefined,
          since: this.filters.date_start
            ? `${this.filters.date_start}`
            : undefined,
          until: this.filters.date_end ? `${this.filters.date_end}` : undefined,
          status_filter: this.filters.status_filter
            ? this.filters.status_filter
            : undefined,
          index_filter: this.filters.shopping_index
            ? this.filters.shopping_index
            : undefined,
          sort_by: this.filters.sort_by ? this.filters.sort_by : undefined,
          sort_order: this.filters.sort_order
            ? this.filters.sort_order
            : undefined,
          assigned_filter:
            this.filters.assigned_filter &&
            this.filters.assigned_filter !==
              REQUEST_SERVICE_CONSTANTS.unassigned_purchase_user
              ? this.filters.assigned_filter
              : undefined,
          unassigned:
            this.filters.assigned_filter &&
            this.filters.assigned_filter ===
              REQUEST_SERVICE_CONSTANTS.unassigned_purchase_user
              ? true
              : undefined,
        });
        if (update_current_service) {
          setTimeout(() => {
            if (self.$refs.tableServicesDetail) {
              self.$refs.tableServicesDetail.updateFilesCurrentService();
            }
          }, 800);
        }
        if (updateTable) {
          self.keyTableRequests = self.keyTableRequests + 1;
        }
        self.loadingQuotes = false;
      }, self.debounceTime);
    },
    async updateSortBy(sortBy) {
      if (sortBy) {
        this.filters.sort_by = sortBy;
        this.filters.sort_order = "asc";
        await this.getRequestsQuotesData();
      } else {
        this.filters.sort_by = "created_at";
        this.filters.sort_order = "desc";
        await this.getRequestsQuotesData();
      }
    },
    async updateSortDesc(sortDesc) {
      if (sortDesc) {
        this.filters.sort_order = "desc";
        await this.getRequestsQuotesData();
      }
    },
    customSort(items, index, isDesc, column) {
      return items;
    },
    requestIsStatusInPendingValidation(request) {
      return (
        request.status ===
        QUOTE_CONSTANTS.quote_statuses_list.pending_validation
      );
    },
    requestIsStatusUserValidationVariant(request) {
      return (
        request.status ===
        QUOTE_CONSTANTS.quote_statuses_list.user_validation_variant
      );
    },
    requestIsStatusInQuotation(request) {
      return (
        request.status === QUOTE_CONSTANTS.quote_statuses_list.in_quotation
      );
    },

    formatAmount(amount, showDecimals = true) {
      if (showDecimals) {
        return new Intl.NumberFormat("es-Cl", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(amount.toString());
      } else {
        return new Intl.NumberFormat("es-Cl", {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        }).format(amount.toString());
      }
    },
    createExchangeRateTable(items, totalPrice = 0) {
      // Create the table structure
      let table = `<table style='border: 1px solid #dededf; height: 100%;width: 100%;table-layout: fixed;border-collapse: collapse;border-spacing: 1px;text-align: left;color: #595959'>
          <thead>
            <tr>
              <th style='border: 1px solid #dededf;background-color: #2778C4;color: #FFFFFF;padding: 5px;'>Descripción</th>
              <th style='border: 1px solid #dededf;background-color: #2778C4;color: #FFFFFF;padding: 5px;'>Tasa de Cambio Utilizada</th>
              <th style='border: 1px solid #dededf;background-color: #2778C4;color: #FFFFFF;padding: 5px;'>Precio</th>
              <th style='border: 1px solid #dededf;background-color: #2778C4;color: #FFFFFF;padding: 5px;'>Monto en Pesos</th>
            </tr>
          </thead>
          <tbody>
        `;

      // Populate the table with items
      items.forEach((item) => {
        table += `
        <tr>
          <td style='border: 1px solid #dededf;background-color: #ffffff;padding: 5px;'>
            ${item.name}
          </td>
          <td style='border: 1px solid #dededf;background-color: #ffffff;padding: 5px;'>
            ${`${item.exchange_rate}`}
          </td>
          <td style='border: 1px solid #dededf;background-color: #ffffff;padding: 5px;'>
            ${item.unit_amount} ${item.coin}
          </td>
          <td style='border: 1px solid #dededf;background-color: #ffffff;padding: 5px;'>
            ${item.coin !== "CLP" ? `${item.amount} CLP` : "---"}
          </td>
        </tr>`;
      });

      // add total CLP
      table += `
        <tr>
          <td></td>
          <td></td>
          <td></td>
          <td style='border: 1px solid #dededf;background-color: #2778C4;color: #FFFFFF;padding: 5px;'>${totalPrice} CLP</td>
        </tr>`;

      // Close the table
      table += "</tbody></table>";

      return table;
    },
    async resolveExchangeRateTable(amount, items) {
      let self = this;
      items.forEach(function(item) {
        item.unit_price = self.getPriceRequest(item).price;
        item.coin = self.getPriceRequest(item).coin;
      });
      const coins = [
        ...new Set(
          items
            .filter((item) => item.coin && item.coin !== "CLP")
            .map((item) => item.coin),
        ),
      ];
      let exchangeRates = [];
      if (coins.length) {
        const promises = coins.map(async (item) => {
          return this.getExchangeRate({ to_currency: item });
        });
        exchangeRates = await Promise.all(promises);
      }

      let totalPrice = 0;
      const dataExchangeTable = items.map((item) => {
        if (item.coin && item.coin !== "CLP") {
          const exchange = exchangeRates.find(
            (exchange) => exchange.to_currency == item.coin,
          );
          totalPrice += Math.round(item.unit_price * exchange.rate * 100) / 100;
          return {
            ...item,
            coin: item.coin ? item.coin : "CLP",
            unit_amount: this.formatAmount(
              item.unit_price,
              item.coin && item.coin !== "CLP",
            ),
            amount: this.formatAmount(
              Math.round(item.unit_price * exchange.rate * 100) / 100,
              false,
            ),
            exchange_rate: `1 ${
              item.coin
            } ⟺ ${exchange.rate.toString().replaceAll(".", ",")} CLP`,
          };
        } else {
          totalPrice += item.unit_price;
          return {
            ...item,
            coin: "CLP",
            unit_amount: this.formatAmount(item.unit_price, false),
            amount: this.formatAmount(item.unit_price, false),
            exchange_rate: "---",
          };
        }
      });

      return this.createExchangeRateTable(
        dataExchangeTable,
        this.formatAmount(totalPrice, false),
      );
    },
    async finishQuote(quote) {
      this.$swal
        .fire({
          icon: "info",
          title: `¿Estas seguro de finalizar esta solicitud con Cesta de Cotización: <b>${quote.shopping_index}</b>?`,
          width: "70%",
          showCancelButton: true,
          showConfirmButton: true,
          confirmButtonColor: "#1076D0",
          confirmButtonText: `Finalizar`,
          cancelButtonText: `Cancelar`,
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            this.loading = true;
            let resp = null;
            let payload = {
              comment: "Finalizar",
              quotation_id: quote.id,
              user: this.user.email,
            };
            resp = await this.sendFinishQuote(payload);
            if (!resp || !resp.status || resp.status == 500) {
              this.$swal({
                icon: "error",
                title: "Error",
                text: "Ha ocurrido un error en el servidor, intenta nuevamente",
                position: "top-end",
                showConfirmButton: false,
                toast: true,
                timer: 3000,
                timerProgressBar: true,
              });
            }
            if (resp.status == 400) {
              this.$swal({
                icon: "error",
                title: "Error",
                text: resp.data.detail,
                position: "top-end",
                showConfirmButton: false,
                toast: true,
                timer: 3000,
                timerProgressBar: true,
              });
            }
            if (resp.status == 200) {
              this.$swal({
                icon: "success",
                title: "Excelente",
                text: `Solicitud finalizada correctamente`,
                position: "top-end",
                showConfirmButton: false,
                toast: true,
                timer: 7000,
                timerProgressBar: true,
              });
              this.getRequestsQuotesData();
            }
            this.loading = false;
          }
        });
    },
    async updateStatusRequestToReviewUser(quote) {
      this.$swal
        .fire({
          icon: "warning",
          title: `¿Estás seguro de enviar esta Solicitud con Cesta de Cotización: <b>${quote.shopping_index}</b> a Revisión por el Usuario?`,
          footer: null,
          showCancelButton: true,
          showConfirmButton: true,
          confirmButtonColor: "#FF9900",
          confirmButtonText: `Enviar`,
          cancelButtonText: `Cancelar`,
          width: "70%",
          input: "textarea",
          inputPlaceholder: "Ingresa el feedback para el usuario solicitante",
          preConfirm: (inputValue) => {
            if (!inputValue) {
              return this.$swal.showValidationMessage(
                "Por favor, ingresa el feedback",
              );
            }
            return inputValue;
          },
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            let resp = null;
            this.loading = true;
            let payload = {
              quotation_id: quote.id,
              user: this.user.email,
              comment: result.value,
            };
            resp = await this.sendUpdateStatusRequestToReviewUser(payload);
            if (!resp || !resp.status || resp.status == 500) {
              this.$swal({
                icon: "error",
                title: "Error",
                text: "Ha ocurrido un error en el servidor, intenta nuevamente",
                position: "top-end",
                showConfirmButton: false,
                toast: true,
                timer: 3000,
                timerProgressBar: true,
              });
            }
            if (resp.status == 400) {
              this.$swal({
                icon: "error",
                title: "Error",
                text: resp.data.detail,
                position: "top-end",
                showConfirmButton: false,
                toast: true,
                timer: 3000,
                timerProgressBar: true,
              });
            }
            if (resp.status == 200) {
              this.$swal({
                icon: "success",
                title: "Excelente",
                text: `Solicitud enviada correctamente a revisión por parte del usuario`,
                position: "top-end",
                showConfirmButton: false,
                toast: true,
                timer: 3000,
                timerProgressBar: true,
              });
              this.getRequestsQuotesData();
            }
            this.loading = false;
          }
        });
    },
    async updateStatusRequestToValidationUser(quote) {
      if (!QUOTE_CONSTANTS.ifServiceHasQuotedFromTeamPurchase(quote.items[0])) {
        return this.$swal.fire({
          icon: "error",
          title: "Error",
          text:
            "El servicio debe tener al menos 1 cotización adjunta por compras",
          position: "top-end",
          showConfirmButton: false,
          toast: true,
          timer: 6000,
          timerProgressBar: true,
        });
      }
      if (
        QUOTE_CONSTANTS.ifServiceHasQuotedWithNoPriceOrSupplierFromTeamPurchase(
          quote.items[0],
        )
      ) {
        return this.$swal.fire({
          icon: "error",
          title: "Error",
          text:
            "Todas las cotizaciones adjuntas deben tener un precio y proveedor definidos",
          position: "top-end",
          showConfirmButton: false,
          toast: true,
          timer: 6000,
          timerProgressBar: true,
        });
      }
      this.$swal
        .fire({
          icon: "warning",
          title: `¿Estás seguro de enviar esta Solicitud con Cesta de Cotización: <b>${quote.shopping_index}</b> a Validación por el Usuario?`,
          footer: null,
          showCancelButton: true,
          showConfirmButton: true,
          confirmButtonColor: "#FF9900",
          confirmButtonText: `Enviar`,
          cancelButtonText: `Cancelar`,
          width: "70%",
          input: "textarea",
          inputPlaceholder: "Ingresa el feedback para el usuario solicitante",
          preConfirm: (inputValue) => {
            if (!inputValue) {
              return this.$swal.showValidationMessage(
                "Por favor, ingresa el feedback",
              );
            }
            return inputValue;
          },
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            let resp = null;
            this.loading = true;
            let payload = {
              quotation_id: quote.id,
              user: this.user.email,
              comment: result.value,
            };
            resp = await this.sendUpdateStatusRequestToValidationUser(payload);
            if (!resp || !resp.status || resp.status == 500) {
              this.$swal({
                icon: "error",
                title: "Error",
                text: "Ha ocurrido un error en el servidor, intenta nuevamente",
                position: "top-end",
                showConfirmButton: false,
                toast: true,
                timer: 3000,
                timerProgressBar: true,
              });
            }
            if (resp.status == 400) {
              this.$swal({
                icon: "error",
                title: "Error",
                text: resp.data.detail,
                position: "top-end",
                showConfirmButton: false,
                toast: true,
                timer: 3000,
                timerProgressBar: true,
              });
            }
            if (resp.status == 200) {
              this.$swal({
                icon: "success",
                title: "Excelente",
                text: `Solicitud enviada correctamente a validación por parte del usuario`,
                position: "top-end",
                showConfirmButton: false,
                toast: true,
                timer: 3000,
                timerProgressBar: true,
              });
              this.getRequestsQuotesData();
            }
            this.loading = false;
          }
        });
    },
    async updateStatusRequestToQuotation(quote, reviewFromUser = false) {
      if (
        reviewFromUser &&
        QUOTE_CONSTANTS.ifServiceHasQuotedWithNoPriceOrSupplier(quote.items[0])
      ) {
        return this.$swal.fire({
          icon: "error",
          title: "Error",
          text:
            "Todas las cotizaciones adjuntas deben tener un precio y proveedor definidos",
          position: "top-end",
          showConfirmButton: false,
          toast: true,
          timer: 6000,
          timerProgressBar: true,
        });
      }
      let message = !reviewFromUser
        ? `¿Estas seguro de Solicitar una Recotización para la solicitud con Cesta de Cotización: <b>${quote.shopping_index}</b> ?`
        : `¿Estas seguro de Enviar la Solicitud con Cesta de Cotización: <b>${quote.shopping_index}</b> a Cotización por Compras?`;
      this.$swal
        .fire({
          icon: "warning",
          title: message,
          showCancelButton: true,
          showConfirmButton: true,
          confirmButtonColor: "#FF9900",
          confirmButtonText: !reviewFromUser ? `Solicitar` : `Enviar`,
          cancelButtonText: `Cancelar`,
          width: "50%",
          input: "textarea",
          inputPlaceholder: "Ingresa el feedback para el equipo de compras",
          preConfirm: (inputValue) => {
            if (!inputValue) {
              return this.$swal.showValidationMessage(
                "Por favor, ingresa el feedback",
              );
            }
            return inputValue;
          },
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            this.loading = true;
            let payload = {
              quotation_id: quote.id,
              user: this.user.email,
              comment: result.value,
            };
            const resp = await this.sendUpdateStatusRequestToQuotationFromUser(
              payload,
            );
            if (!resp || !resp.status || resp.status == 500) {
              this.$swal({
                icon: "error",
                title: "Error",
                text: "Ha ocurrido un error en el servidor, intenta nuevamente",
                position: "top-end",
                showConfirmButton: false,
                toast: true,
                timer: 3000,
                timerProgressBar: true,
              });
            }
            if (resp.status == 400) {
              this.$swal({
                icon: "error",
                title: "Error",
                text: resp.data.detail,
                position: "top-end",
                showConfirmButton: false,
                toast: true,
                timer: 3000,
                timerProgressBar: true,
              });
            }
            if (resp.status == 200) {
              this.$swal({
                icon: "success",
                title: "Excelente",
                text: !reviewFromUser
                  ? `Recotización solicitada correctamente`
                  : `Solicitud enviada correctamente a cotización por compras`,
                position: "top-end",
                showConfirmButton: false,
                toast: true,
                timer: 3000,
                timerProgressBar: true,
              });
              this.getRequestsQuotesData(this.filters.page, false, true);
            }
            this.loading = false;
          }
        });
    },
    async updateStatusRequestToRejection(quote) {
      this.$swal
        .fire({
          icon: "error",
          title: `¿Estas seguro de Rechazar la Solicitud con Cesta de Cotización: <b>${quote.shopping_index}</b>?`,
          showCancelButton: true,
          showConfirmButton: true,
          confirmButtonColor: "#FF0000",
          confirmButtonText: `Rechazar`,
          cancelButtonText: `Cancelar`,
          width: "50%",
          input: "textarea",
          inputPlaceholder: "Ingresa el Motivo de Rechazo",
          preConfirm: (inputValue) => {
            if (!inputValue) {
              return this.$swal.showValidationMessage(
                "Por favor, ingresa el motivo de rechazo",
              );
            }
            return inputValue;
          },
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            this.loading = true;
            let resp = null;
            let payload = {
              quotation_id: quote.id,
              user: this.user.email,
              comment: result.value,
            };
            if (this.requestingUserModule) {
              resp = await this.sendUpdateStatusRequestToCancelFromUser(
                payload,
              );
            } else {
              resp = await this.sendUpdateStatusRequestToRejection(payload);
            }

            if (!resp || !resp.status || resp.status == 500) {
              this.$swal({
                icon: "error",
                title: "Error",
                text: "Ha ocurrido un error en el servidor, intenta nuevamente",
                position: "top-end",
                showConfirmButton: false,
                toast: true,
                timer: 3000,
                timerProgressBar: true,
              });
            }
            if (resp.status == 400) {
              this.$swal({
                icon: "error",
                title: "Error",
                text: resp.data.detail,
                position: "top-end",
                showConfirmButton: false,
                toast: true,
                timer: 3000,
                timerProgressBar: true,
              });
            }
            if (resp.status == 200) {
              this.$swal({
                icon: "success",
                title: "Excelente",
                text: `Solicitud Rechazada correctamente`,
                position: "top-end",
                showConfirmButton: false,
                toast: true,
                timer: 3000,
                timerProgressBar: true,
              });
              this.getRequestsQuotesData();
            }
            this.loading = false;
          }
        });
    },
    openModalCommentsRequest(item) {
      this.currentRequest = item;
      this.dialogCommmentsRequest = true;
    },
    closeModalCommentsRequest() {
      this.currentRequest = null;
      this.dialogCommmentsRequest = false;
    },
    openModalServicesDeleted(item) {
      this.currentRequest = item;
      this.dialogServicesDeleted = true;
    },
    closeModalServicesDeleted() {
      this.currentRequest = null;
      this.dialogServicesDeleted = false;
    },
    openModalAssignUserQuote(item) {
      this.currentRequest = item;
      this.dialogAssignUserQuote = true;
    },
    closeModalAssignUserQuote() {
      this.currentRequest = null;
      this.dialogAssignUserQuote = false;
    },
  },
  computed: {
    ...authUsuarioComputed,
    ...mapGetters({
      quotes: "quote/quotes",
      listEmployeesToAssignRequestQuote:
        "quote/listEmployeesToAssignRequestQuote",
    }),
    wrappedListEmployeesToAssignRequestQuote() {
      return this.listEmployeesToAssignRequestQuote.employees.map((item) => {
        return {
          label: `${item.email}`,
          ...item,
        };
      });
    },
    date_start_formatted: {
      get() {
        if (this.filters.date_start) {
          return moment(this.filters.date_start).format("DD/MM/YYYY");
        }
        return null;
      },
      set() {},
    },
    date_end_formatted: {
      get() {
        if (this.filters.date_end) {
          return moment(this.filters.date_end).format("DD/MM/YYYY");
        }
        return null;
      },
      set() {},
    },
    minDateEnd() {
      if (this.filters.date_start) {
        return this.filters.date_start;
      }
      return null;
    },
    maxDateStart() {
      if (this.filters.date_end) {
        return this.filters.date_end;
      }
      return null;
    },
    wrappedHeaders() {
      return this.tableHeaders;
    },
  },
  watch: {
    "filters.page": function(page) {
      this.getRequestsQuotesData(page, false, true);
    },
  },
};
</script>

<style>
.custom-font .v-select__slot {
  font-size: 12px !important;
}
</style>